import { defineStore } from "pinia";

interface DirectionsState {
  banner: string;
  blocLeft: string;
  blocRight: string;
}

export const elementsDirectionStore = defineStore("direction", {
  state: (): DirectionsState => ({
    banner: "right",
    blocLeft: "reset",
    blocRight: "reset",
  }),

  actions: {
    bannerDirection(dir: string) {
      if (dir === "fullopen") {
        this.openAll();
        return;
      } else if (dir === "reset") {
        this.slideToReset();
        return;
      }
      this.banner = dir;
    },

    slideToReset() {
      this.blocLeft = "reset";
      this.blocRight = "reset";
      this.banner = "right";
    },

    openAll() {
      this.blocLeft = "left";
      this.blocRight = "right";
      if (this.banner === "right") {
        this.banner = "fullright";
        return;
      }
      this.banner = "fullleft";
    },
  },
});
